import { useState } from "react";
import { Calendar as CalendarIcon, Plus, List } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CalendarView } from "@/components/calendar/CalendarView";
import { EventsList } from "@/components/calendar/EventsList";
import { CreateEventDialog } from "@/components/calendar/CreateEventDialog";

export default function Calendar() {
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [activeView, setActiveView] = useState("calendar");

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Calendar & Scheduling</h1>
          <p className="text-muted-foreground">Manage your meetings, deadlines, and events</p>
        </div>
        <Button onClick={() => setIsCreateOpen(true)} size="lg">
          <Plus className="mr-2 h-5 w-5" />
          New Event
        </Button>
      </div>

      <Tabs value={activeView} onValueChange={setActiveView} className="space-y-6">
        <TabsList>
          <TabsTrigger value="calendar">
            <CalendarIcon className="mr-2 h-4 w-4" />
            Calendar View
          </TabsTrigger>
          <TabsTrigger value="list">
            <List className="mr-2 h-4 w-4" />
            List View
          </TabsTrigger>
        </TabsList>

        <TabsContent value="calendar">
          <CalendarView />
        </TabsContent>

        <TabsContent value="list">
          <EventsList />
        </TabsContent>
      </Tabs>

      <CreateEventDialog open={isCreateOpen} onOpenChange={setIsCreateOpen} />
    </div>
  );
}